import React from "react";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
// import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";

import ReactTable from "react-table";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import green from "@material-ui/core/colors/green";
import Switch from "@material-ui/core/Switch";
import toastr from "toastr";
import axios from "axios";
import { domain } from "../../utils/util";

toastr.options = {
  closeButton: true,
};

export class ViewOfficer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userData: null,
      familyData: null,
    };
  }
  componentWillMount = () => {
    if (
      this.props &&
      this.props.history &&
      this.props.history.location &&
      this.props.history.location.state &&
      this.props.history.location.state.data
    ) {
      let userData = this.props.history.location.state.data;
      this.setState({
        userData,
      });
    }
  };

  render() {
    const { classes } = this.props;
    let { userData, familyData } = this.state;
    return (
      <div className="add-category-form">
        <Card>
          <CardContent>
            <GridContainer>
              <GridItem xs={12}>
                {userData.profile_pic ? (
                  <img
                    className="profile_pic view_main"
                    src={userData.profile_pic}
                  />
                ) : null}

                <TextField
                  autoFocus
                  margin="dense"
                  id="name"
                  label="Full Name"
                  type="name"
                  fullWidth
                  value={userData.first_name ? userData.first_name : ""}
                  style={{ marginBottom: "20px" }}
                />

                <TextField
                  autoFocus
                  margin="dense"
                  id="name"
                  label="Badge Number"
                  type="name"
                  fullWidth
                  value={userData.badge_number ? userData.badge_number : ""}
                  style={{ marginBottom: "20px" }}
                />

                <TextField
                  autoFocus
                  margin="dense"
                  id="name"
                  label="Account Type"
                  type="name"
                  fullWidth
                  value={userData.account_type ? userData.account_type : ""}
                  style={{ marginBottom: "20px" }}
                />

                <TextField
                  autoFocus
                  margin="dense"
                  id="name"
                  label="Gender"
                  type="name"
                  fullWidth
                  value={userData.gender ? userData.gender : ""}
                  style={{ marginBottom: "20px" }}
                />
                <TextField
                  autoFocus
                  margin="dense"
                  id="name"
                  label="Email Address"
                  type="name"
                  fullWidth
                  value={userData.email ? userData.email : ""}
                  style={{ marginBottom: "20px" }}
                />
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <div style={{ paddingTop: "15px" }}>Block/ UnBlock</div>
                  <div>
                    <Switch
                      placeholder="Block/UnBlock"
                      className={
                        userData.status == "active"
                          ? "main_switch_btns toggle_active"
                          : "main_switch_btns toggle_inactive"
                      }
                      checked={userData.status == "active" ? true : false}
                      onChange={(e) => {
                        let data = JSON.parse(
                          localStorage.getItem("BerPay_Admin")
                        );
                        let config = {};
                        if (data && data.token) {
                          config = {
                            headers: { Authorization: `Bearer ${data.token}` },
                          };
                        }
                        e.stopPropagation();
                        let state = !userData.status;
                        let id = userData._id;
                        let body = {
                          id: id,
                        };
                        if (userData.status == "active") {
                          body.status = "disable";
                        } else {
                          body.status = "active";
                        }

                        axios
                          .put(`${domain}/user/update/appuser`, body, config)
                          .then((res) => {
                            if (
                              res.data.statusCode === 200 ||
                              res.data.statusCode === 201
                            ) {
                              if (userData.status == "active") {
                                toastr.success("User Blocked Successfully!");
                              } else {
                                toastr.success("User Unblocked Successfully!");
                              }
                              this.props.history.goBack();
                            }
                          })
                          .catch((error) => {});
                      }}
                      color="primary"
                      name="active"
                      inputProps={{ "aria-label": "primary checkbox" }}
                    />
                  </div>
                </div>
              </GridItem>
            </GridContainer>
          </CardContent>
        </Card>
      </div>
    );
  }
}

export default ViewOfficer;
